import Swiper from 'swiper';
import { Navigation, Pagination, Mousewheel } from 'swiper/modules';

function updateFocusability(swiper) {
  swiper.slides.forEach(slide => {
    const visible = slide.classList.contains('swiper-slide-visible');
    slide.querySelectorAll('a, button').forEach(el => {
      if (visible) {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', '-1');
      }
    });
  });
}

export default function initSwiper() {
  document.querySelectorAll('[data-carousel-cards]').forEach(holder => {
    const section = holder.closest('section');
    const paginationEl = holder.querySelector('[data-dots]');
    const prevEl = section ? section.querySelector('[data-nav-prev]') : null;
    const nextEl = section ? section.querySelector('[data-nav-next]') : null;

    const isAutoView = holder.hasAttribute('data-slide-view-auto');

    new Swiper(holder, {
      modules: [Pagination, Navigation, Mousewheel],
      spaceBetween: 20,
      slidesPerView: isAutoView ? 'auto' : 1,
      watchSlidesProgress: true,
      mousewheel: { forceToAxis: true },
      pagination: {
        el: paginationEl,
        bulletClass: 'dot',
        bulletActiveClass: 'is-active',
        clickable: true,
        renderBullet(index, className) {
          return `<button type="button" class="${className}" aria-label="Go to slide ${index + 1}"></button>`;
        },
      },
      navigation: {
        prevEl,
        nextEl,
      },
      breakpoints: {
        768: { slidesPerView: isAutoView ? 'auto' : 2 },
        1024: {
          spaceBetween: 30,
          slidesPerView: isAutoView ? 'auto' : 3 ,
        },
      },
      on: {
        init(swiper) {
          updateFocusability(swiper);
        },
        slideChangeTransitionEnd(swiper) {
          updateFocusability(swiper);
        },
        breakpoint(swiper) {
          updateFocusability(swiper);
        },
      },
    });
  });
}
